import { Box, Flex, IconButton } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import SectionHeading from "../../components/SectionHeading";
import SectionWrapper from "../../components/SectionWrapper";
import Slider from "react-slick";
// import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MaterialList.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import useMaterialData from "../../hooks/useMaterialData";
import image2 from "../../assets/extracted-images/image7.png";
import Img from "../../components/Img";
import { materials } from "../../utils/materialData";
import axios from "axios";
import PopupWrapper from "../../components/PopupWrapper";
import {
  getAxiosConfig,
  getMinioImage,
  MaterialBannerData,
} from "../../utils/helpers";
import FullPageImageSlider from "../../components/FullPageImageSlider";
import { useNavigate } from "react-router-dom";

const MaterialList = () => {
  const [list, setList] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const nav = useNavigate();
  //   let materials= useMaterialData();
  //   console.log(materials[128]);
  //   let unique={};
  // let info = materials.filter(v => v.designs.Images.length!=0).map(v=> ({name: v.material, image: v.designs.Images?.[0]})).filter((v)=> {
  //   if(unique[v.name]){
  //     return false;
  //   }
  //   else{
  //     unique[v.name] = "Present"
  //     return true;
  //   }
  // });
  // console.log(info );
  const sliderRef = useRef(null);

  const next = () => {
    sliderRef.current?.slickNext();
  };

  const previous = () => {
    sliderRef.current?.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  //   let list = [
  //     {
  //       name: "Steel",
  //       image: "https://source.unsplash.com/random/400x300/?steel",
  //     },
  //     {
  //       name: "Wood",
  //       image: "https://source.unsplash.com/random/400x300/?wood",
  //     },
  //     {
  //       name: "Glass",
  //       image: "https://source.unsplash.com/random/400x300/?glass",
  //     },
  //     {
  //       name: "Plastic",
  //       image: "https://source.unsplash.com/random/400x300/?plastic",
  //     },
  //     {
  //       name: "Aluminum",
  //       image: "https://source.unsplash.com/random/400x300/?aluminum",
  //     },
  //     {
  //       name: "Marble",
  //       image: "https://source.unsplash.com/random/400x300/?marble",
  //     },
  //     {
  //       name: "Granite",
  //       image: "https://source.unsplash.com/random/400x300/?granite",
  //     },
  //     {
  //       name: "Brick",
  //       image: "https://source.unsplash.com/random/400x300/?brick",
  //     },
  //     {
  //       name: "Concrete",
  //       image: "https://source.unsplash.com/random/400x300/?concrete",
  //     },
  //     {
  //       name: "Leather",
  //       image: "https://source.unsplash.com/random/400x300/?leather",
  //     },
  //   ];

  // list = materials.map((v)=> ({name: v.materialName, image : v.materialData?.[0]?.image}))

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/material/get-all`,
          getAxiosConfig(),
        );
        console.log(data);
        setList(
          data?.data?.collections?.map((v) => ({
            name: v?.materialName,
            image: getMinioImage(v.images?.[0]),
          })),
        );
      } catch (error) {}
    };
    fetchMaterials();
  }, []);

  return (
    <SectionWrapper
      heading={"Materials"}
      rightComponent={
        <Flex gap={2} alignItems="center">
          <IconButton
            onClick={previous}
            aria-label="Previous"
            icon={
              <Icon
                icon={"material-symbols:arrow-circle-left-outline"}
                boxSize={5}
                width={"28px"}
              />
            }
            variant="ghost"
            colorScheme="teal"
            rounded="full"
            size="sm"
            _hover={{ bg: "teal.50" }}
          />
          <IconButton
            onClick={next}
            aria-label="Next"
            icon={
              <Icon
                icon={"material-symbols:arrow-circle-left-outline"}
                boxSize={5}
                width={"28px"}
                rotate={"180deg"}
              />
            }
            variant="ghost"
            colorScheme="teal"
            rounded="full"
            size="sm"
            _hover={{ bg: "teal.50" }}
          />
        </Flex>
      }
    >
      <Box px={0} className="material-slider">
        <Slider ref={sliderRef} {...settings}>
          {MaterialBannerData.map((material, idx) => (
            <Box
              key={idx}
              onClick={() =>
                nav(`material-filter?type=${encodeURIComponent(material.type)}`)
              }
            >
              <Box
                overflow="hidden"
                borderRadius="lg"
                boxShadow="sm"
                transition="all 0.2s"
                _hover={{
                  transform: "translateY(-4px)",
                  boxShadow: "md",
                }}
                // onClick={() => setSelectedMaterial({ ...material, idx })}

                // h={"100%"}
              >
                <Img
                  src={material.icons}
                  alt={material.type}
                  width="60px"
                  height="60px"
                  objectFit="cover"
                  className={
                    " w-[60px] h-[60px] mx-auto object-contain cursor-pointer "
                  }
                />

                <Box
                  p={1}
                  textAlign="center"
                  fontWeight="semibold"
                  color="gray.700"
                  fontSize={"xsm"}
                >
                  {material.type}
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
      {selectedMaterial && (
        <FullPageImageSlider
          images={list.map((m) => m.image)}
          isOpen={!!selectedMaterial}
          onClose={() => setSelectedMaterial(null)}
          initialIndex={selectedMaterial.idx}
        />
      )}
      {/* {selectedMaterial && (
        <PopupWrapper
          isShowAction={false}
          width="w-3/4 md:w-1/2 lg:w-1/3 text-center"
          // heading="Material Details"
          onClose={() => setSelectedMaterial(null)}
        >
          <Box>
            <Img src={selectedMaterial?.image} />
          </Box>
        </PopupWrapper>
      )} */}
    </SectionWrapper>
  );
};

export default MaterialList;
